import Auth from '../auth/Auth';
import DefaultAircraft from "../models/DefaultAircraft";
import { WebClient } from './WebClient'

class ApiDefaultAircraft extends WebClient {
    async getDefaultAircraft(): Promise<DefaultAircraft[]> {
        const url = "/aircraft/default";

        return this.get(url, Auth.getAuthToken()).then(res => {
            if (res.status === 200) {
                return res.data || [];
            }
            return [];
        }).catch(() => { return []; });
    }

    async updateDefaultAircraft(data: DefaultAircraft): Promise<DefaultAircraft> {
        return this.post("/aircraft/default", data, Auth.getAuthToken()).then(res => {
            if (res.status === 200) {
                return res.data;
            }
            return null;
        }).catch(() => { return null; });
    }


    async deleteDefaultAircraft(aircraft: string, fleetCode: string, configurationCode: string): Promise<boolean> {
        return this.delete(`/aircraft/default/${aircraft}/${fleetCode}/${configurationCode}`, Auth.getAuthToken()).then(res => {
            return res.status === 200;
        }).catch(() => { return false; });
    }
}

export default new ApiDefaultAircraft();
